<script>
import { authComputed, orgComputed, orgMethods } from '@state/helpers';

export default {
  components: {},
  computed: {
    ...authComputed,
    ...orgComputed,
    logoUrl() {
      return process.env.VUE_APP_ORG_ID === '618183d65e84466f63c38878'
        ? 'https://tandem-email.s3.amazonaws.com/pmeo-logo-light.png'
        : 'https://tandem-email.s3.amazonaws.com/smartfitness-logo.png';
    },
    colors() {
      return {
        '--color': this.primaryColor,
      };
    },
  },
  methods: {
    ...orgMethods,
  },
};
</script>

<template>
  <header>
    <nav>
      <div class="logo">
        <router-link to="/">
          <img :src="logoUrl" alt="smartfitness" />
        </router-link>
      </div>
      <div class="links" v-if="!loggedIn">
        <!-- <div id="link1">
          <button @click="$emit('activate-about')">About</button>
        </div> -->
        <div id="link1">
          <router-link :style="colors" to="/login">
            <button>Login</button>
          </router-link>
        </div>
      </div>
      <!-- <div class="button" v-if="!loggedIn">
        <router-link to="/signup">
          <BaseButton class="small" id="signup">Sign Up</BaseButton>
        </router-link>
      </div> -->
      <div class="no-button" v-else></div>
    </nav>
  </header>
</template>

<style lang="scss" scoped>
// stylelint-disable selector-max-type
header {
  height: auto;
  width: 100%;
  .menu {
    display: none;

    img {
      width: 5%;
    }
  }
  nav {
    align-items: center;
    display: flex;
    flex-wrap: wrap;
    height: 6%;
    margin-left: 8.3%;
    margin-right: 8.3%;
    margin-top: 30px;
    width: 83.4%;

    .logo {
      margin-left: 44px;
      img {
        width: 176.9px;
      }
    }

    .links {
      display: flex;
      margin-left: 20px;

      button {
        background: none;
        border: none;
        border-radius: none;
        color: white;
        cursor: pointer;
        font-family: 'Roboto', sans-serif;
        font-size: 17px;
        outline: none;
        -webkit-transition-duration: 0.3s;
      }

      :hover {
        color: var(--color);
      }
    }

    .button {
      display: inline;
      flex-grow: 5.5;

      // #signup {
      //   float: right;
      // }
    }

    .no-button {
      height: 53px;
    }
  }
}
</style>
